module.exports = __webpack_public_path__ + "static/PMB_framsida_clouds-2475414f5464e148f9ce90bca558bbad.png";